// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Box, FormControlLabel, Radio, Typography } from '@mui/material';

interface Props {
  fieldLabel: string;
  primaryValue: string | null;
  selectedValue: string | null;
  mergedValue: string | null;
  showRadio: boolean;
  selection: 'primary' | 'selected';
  fieldKey: string;
  onSelectionChange: (field: string, source: 'primary' | 'selected') => void;
}

export function FieldComparisonRow(props: Props) {
  return (
    <Box
      display="grid"
      gridTemplateColumns="2fr 2fr 2fr 3fr"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        px: 2,
        py: 2,
        alignItems: 'center',
      }}
    >
      <Typography variant="body2">{props.fieldLabel}</Typography>

      <Box>
        {props.showRadio ? (
          <FormControlLabel
            control={
              <Radio
                checked={props.selection === 'primary'}
                onChange={() =>
                  props.onSelectionChange(props.fieldKey, 'primary')
                }
                size="small"
              />
            }
            label={
              <Typography variant="body2">
                {props.primaryValue || (
                  <Typography component="span" color="text.secondary">
                    Not set
                  </Typography>
                )}
              </Typography>
            }
          />
        ) : (
          <Typography variant="body2">
            {props.primaryValue || (
              <Typography component="span" color="text.secondary">
                Not set
              </Typography>
            )}
          </Typography>
        )}
      </Box>

      <Box>
        {props.showRadio ? (
          <FormControlLabel
            control={
              <Radio
                checked={props.selection === 'selected'}
                onChange={() =>
                  props.onSelectionChange(props.fieldKey, 'selected')
                }
                size="small"
              />
            }
            label={
              <Typography variant="body2">
                {props.selectedValue || (
                  <Typography component="span" color="text.secondary">
                    Not set
                  </Typography>
                )}
              </Typography>
            }
          />
        ) : (
          <Typography variant="body2">
            {props.selectedValue || (
              <Typography component="span" color="text.secondary">
                Not set
              </Typography>
            )}
          </Typography>
        )}
      </Box>

      <Box>
        <Typography variant="body2">
          {props.mergedValue || (
            <Typography component="span" color="text.secondary">
              Not set
            </Typography>
          )}
        </Typography>
      </Box>
    </Box>
  );
}
